// store/index.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import documentReducer from "./documentSlice.js";
import selectedUserReducer from "./selectedUserSlice.js";
import cardReducer from "./selectedCard.js";
import requestDotReducer from "./requestDots.js";
import deletedAccountReducer from "./selectedAccountDeleted.js";
import archievedAccountReducer from "./selectedAccountArchieved.js";
import investmentReducer from "./investmentId.js";
import portfolioInvestmentReducer from "./portfolioInvestmentId.js";
import investorReducer from "./investor.js";
import inspecieTransferReducer from "./inspecie-transfer.js";
import formReducer from "./onboardingFormSlice.js";
import accountTypeReducer from "./accountTypeSlice.js";

const store = configureStore({
  reducer: {
    user: userReducer,
    documents: documentReducer,
    selectedUsers: selectedUserReducer,
    cards: cardReducer,
    request: requestDotReducer,
    deletedAccount: deletedAccountReducer,
    archivedAccount: archievedAccountReducer,
    investment: investmentReducer,
    portfolioInvestment: portfolioInvestmentReducer,
    investor: investorReducer,
    inspecieTransfer: inspecieTransferReducer,
    form: formReducer,
    accountType: accountTypeReducer,
  },
});

export default store;
